export const Selectors = {
  widdeDiv: "widdeDiv",
  currentProgress: "current-progress",
  mainVideoId: "main-video"
};
